import { LIST_PERMISSION } from '@/constant/ListPermission';

const DEGREE_IDS = {
  ELEMENTARY_SCHOOL_I: 4,
  ELEMENTARY_SCHOOL_II: 1,
  HIGH_SCHOOL: 2,
  SAEB: 5,
  ENEM: 6,
  EJA: 3
};

export const PERMISSION_NAME_BY_DEGREE_ID = {
  [DEGREE_IDS.ELEMENTARY_SCHOOL_II]: LIST_PERMISSION.BOOKS_DEGREE_ELEMENTARY_SCHOOL_II,
  [DEGREE_IDS.HIGH_SCHOOL]: LIST_PERMISSION.BOOKS_DEGREE_HIGH_SCHOOL,
  [DEGREE_IDS.SAEB]: LIST_PERMISSION.BOOKS_DEGREE_SAEB,
  [DEGREE_IDS.ENEM]: LIST_PERMISSION.BOOKS_DEGREE_ENEM,
  [DEGREE_IDS.EJA]: LIST_PERMISSION.BOOKS_DEGREE_EJA
};

export const DEGREE_ID_BY_PERMISSION_NAME = {
  [LIST_PERMISSION.BOOKS_DEGREE_ELEMENTARY_SCHOOL_II]: DEGREE_IDS.ELEMENTARY_SCHOOL_II,
  [LIST_PERMISSION.BOOKS_DEGREE_HIGH_SCHOOL]: DEGREE_IDS.HIGH_SCHOOL,
  [LIST_PERMISSION.BOOKS_DEGREE_SAEB]: DEGREE_IDS.SAEB,
  [LIST_PERMISSION.BOOKS_DEGREE_ENEM]: DEGREE_IDS.ENEM,
  [LIST_PERMISSION.BOOKS_DEGREE_EJA]: DEGREE_IDS.EJA
};

export function hasPermissionForDegree(degreeID: number, permissionClass: any): boolean {
  const basePermission = PERMISSION_NAME_BY_DEGREE_ID[degreeID];

  if (basePermission && permissionClass.can(basePermission)) {
    return true;
  }

  if (degreeID === DEGREE_IDS.ELEMENTARY_SCHOOL_I || degreeID === DEGREE_IDS.ELEMENTARY_SCHOOL_II) {
    return permissionClass.can(LIST_PERMISSION.DEGREE_1_EARLY_YEARS) 
    || permissionClass.can(LIST_PERMISSION.DEGREE_1_FINAL_YEARS);
  }

  return false;
}
